import { render } from "./FicheProduit.vue?vue&type=template&id=30c720e0&ts=true"
import script from "./FicheProduit.vue?vue&type=script&lang=ts"
export * from "./FicheProduit.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__